import React, { useContext } from 'react'
import { ConfiguratorContext } from "app/React/ConfiguratorContainer";

export default function IsDealerConfigurator(props) {
  const { isDealerConfigurator } = useContext(ConfiguratorContext)

  if (!isDealerConfigurator) {
    return null
  }

  return <>{props.children}</>
}
